<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="content-chapter" id="_idParaDest-4"><a href="#/ChakraTonicsebk3#_idTextAnchor003">note to readers<span id="_idTextAnchor022"></span> </a></p>
<p class="body_Body-First _idGenParaOverride-1">This book is not meant to treat, diagnose, or prescribe. The information contained herein is in no way to be considered as a substitute for your own inner guidance. For any medical condition, physical condition, or symptoms, always consult with a qualified physician or appropriate health care professional. Neither the author nor the publisher accepts any responsibility for your health or how you choose to use the recipes in <span class="noBreak">this</span><span class="noBreak"> </span><span class="noBreak">book.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ChakraTonicsebk4.vue?e6bfd446